// Sales summary figures, shared by Historial de Ventas (its cards) and Resumen de Ventas.
//   Cajas 43lbs  = cajas × peso caja ÷ 43 (= cajas for a brand with "Precio real a 43 lbs", whose
//                  boxes count as 43 lbs)
//   Total real   = Σ cajas × precio real
//   Total 43lbs  = Σ cajas 43lbs × precio 43 (always equal to Total real: precio real = precio 43
//                  ÷ 43 × peso)
//   Promedios    = Total real ÷ cajas (weighted by boxes)
// Money figures and their boxes only count sales with a Precio 43 (not empty, not 0,00).

export const isMissingPrice = (sale) => sale.price === null || sale.price === undefined || sale.price === ''
  || Number(sale.price) === 0;

export const boxes43 = (sale) => {
  const boxes = Number(sale.boxes) || 0;
  return sale.brand_real_price_at_43 ? boxes : boxes * (Number(sale.fruit_weight) || 0) / 43;
};

export const fmtMoney = (n) => (n == null
  ? '—' : `$${n.toLocaleString('es-EC', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

// The raw sums behind the summary, so weeks (live or closed) can be added up into a total.
export function sumSales(sales) {
  const priced = sales.filter((s) => !isMissingPrice(s));
  return {
    count: sales.length,
    totalBoxes: sales.reduce((t, s) => t + (s.boxes || 0), 0),
    totalBoxes43: sales.reduce((t, s) => t + boxes43(s), 0),
    pricedCount: priced.length,
    pricedBoxes: priced.reduce((t, s) => t + (s.boxes || 0), 0),
    pricedBoxes43: priced.reduce((t, s) => t + boxes43(s), 0),
    totalReal: priced.reduce((t, s) => t + (s.boxes || 0) * Number(s.real_price || 0), 0),
  };
}

// The same sums from closed weeks (sales-closes/, core.WeeklySalesClose).
export function sumCloses(closes) {
  const n = (v) => Number(v) || 0;
  return {
    count: closes.reduce((t, c) => t + n(c.sales_count), 0),
    totalBoxes: closes.reduce((t, c) => t + n(c.total_boxes), 0),
    totalBoxes43: closes.reduce((t, c) => t + n(c.total_boxes_43), 0),
    pricedCount: closes.reduce((t, c) => t + (n(c.priced_boxes) ? 1 : 0), 0),
    pricedBoxes: closes.reduce((t, c) => t + n(c.priced_boxes), 0),
    pricedBoxes43: closes.reduce((t, c) => t + n(c.priced_boxes_43), 0),
    totalReal: closes.reduce((t, c) => t + n(c.total_real), 0),
  };
}

export const addSums = (a, b) => Object.fromEntries(Object.keys(a).map((k) => [k, a[k] + b[k]]));

export function finishSums(t) {
  return {
    ...t,
    totalReal: t.pricedCount ? t.totalReal : null,
    total43: t.pricedCount ? t.totalReal : null,
    avgReal: t.pricedBoxes ? t.totalReal / t.pricedBoxes : null,
    avg43: t.pricedBoxes43 ? t.totalReal / t.pricedBoxes43 : null,
  };
}

export const summarizeSales = (sales) => finishSums(sumSales(sales));
